<template>
  <div class="page">
    <ul>
      <li class="list_item" v-for="item in list" :key="item.id">
        <div class="title">
          <div class="status" v-if="item.status == 0"></div>
          <span>更新提醒</span>
        </div>
        <div class="desc">您收藏的期刊「{{ item.title }}」更新了</div>
        <div class="time">{{ item.createTime }}</div>
        <el-divider></el-divider>
      </li>
    </ul>
    <div ref="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNo"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getNewsPage } from "@/api/api.js";
export default {
  data() {
    return {
      list: [],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 1,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await getNewsPage(this.queryParams);
      this.list = res.data.data.rows;
      this.total = res.data.data.totalRows;
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100%;
}
::v-deep .pagination-container .el-pagination {
  right: 0;
  position: absolute;
  bottom: 0;
}
ul {
  max-height: 650px;
  overflow: auto;
}
.list_item {
  cursor: pointer;
  .title,
  .desc {
    margin-bottom: 15px;
  }
  .title,
  .time {
    color: #aca9ac;
  }
  .desc {
    color: #000;
    font-weight: 600;
  }
  .title{
    display: flex;
    align-items: center;
    .status{
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: orange;
      margin-right: 5px;
    }
  }
}
</style>
